import { render, staticRenderFns } from "./PointOfContactsList.html?vue&type=template&id=6977e0ea&external"
import script from "./PointOfContactsList.js?vue&type=script&lang=js&external"
export * from "./PointOfContactsList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports